<template>
    <div class="modal fade" id="messageDialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-message-content-scv">
                <div class="modal-header modal-header-scv-cmn" style="width: 100%">
                    <div class="modal-header-text-box-scv" style="width: 100%">
                        <span class="modal-header-text-scv">
                            {{GetType(messageType)}}
                        </span>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" href="#" role="button" @click="onBtnOk(selectOKFunc)">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <template v-if="IsMultiLine(messageText) === true && isScroll">
                        <div class="d-flex flex-row">
                            <img :src="GetIcon(messageType)" height="24" style="margin-right: 8px" />
                            <span v-html="messageText" style="margin-top: 4px; overflow-y: auto; min-height:50px; max-height:500px; word-break: break-all;"></span>
                        </div>
                    </template>
                    <template v-else-if="IsMultiLine(messageText) === true">
                        <div class="d-flex flex-row">
                            <img :src="GetIcon(messageType)" height="24" style="margin-right: 8px" />
                            <span v-html="messageText" style="margin-top: 4px;"></span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="d-flex flex-row align-items-center">
                            <img :src="GetIcon(messageType)" height="24" style="margin-right: 8px" />
                            <span v-html="messageText"></span>
                        </div>
                    </template>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-blue" @click="onBtnOk(selectOKFunc)">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import $ from "jquery";
    import { MessageType } from '@/models/Message/MessageType';
    import errorColor from "@/assets/img/guide_error_color.svg";
    import alertColor from "@/assets/img/guide_alert_color.svg";
    import infoColor from "@/assets/img/guide_info_color.svg";
    import { BootstrapUtil } from 'lib-vue-v2/util';

    @Options({
        components: {
        },
        props: {
            messageType: Number,
            messageText: String,
            selectOKFunc: Function,
            isScroll: {type: Boolean, default: false}
        },
        emits: [
            'onSelectOK'
        ],
        methods: {
            GetType(messageType: number): string {
                if (messageType === MessageType.Error) {
                    return "エラー";
                }
                else if (messageType === MessageType.Warning) {
                    return "警告";
                }
                return "情報";
            },

            GetIcon(messageType: number) {
                if (messageType === MessageType.Error) {
                    return errorColor;
                }
                else if (messageType === MessageType.Warning) {
                    return alertColor;
                }
                return infoColor;
            },

            IsMultiLine(messageText: string): boolean {
                return (0 <= messageText.indexOf('<br'));
            }
        },
    })

    // メッセージダイアログコンポーネント
    export default class MessageDialog extends Vue {
        // 発行済みメッセージダイアログID
        private static issuedMessageIDNumber = 0;
        // 自身のメッセージダイアログID
        private myMessageID = "";

        /**
         * @brief   mounted
         */
        public mounted() {
            // 発行済みIDをインクリメントして他のメッセージダイアログとIDが重複しないようにする
            MessageDialog.issuedMessageIDNumber += 1;
            this.myMessageID = 'messageDialog' + MessageDialog.issuedMessageIDNumber.toString();
            $('#messageDialog').attr('id', this.myMessageID);
        }

        /**
         * @brief   割り振られたIDを取得
         */
        public GetID(): string {
            return this.myMessageID;
        }

        /**
         * @brief   OKボタン押下
         */
        public onBtnOk(selectOKFunc: any): void {
            BootstrapUtil.hideModal(this.GetID());
            this.$emit('onSelectOK', selectOKFunc);
        }
    }

</script>

<style>
</style>
